import React, { useState } from "react";
import Alert from "../UI/Modal/Alert";
import { useNavigate } from "react-router-dom";

const ErrorInicis = () => {
    const navigate = useNavigate();
    const [showCancelModal, setShowCancelModal] = useState(true);

    const modalHandler = (state) => {
        setShowCancelModal(state);
        navigate("/myPage/tournamentHistory");
        //window.location.href="/myPage/tournamentHistory"
    };

    return (
        <>
            {showCancelModal && (
                <Alert type="alert" confirm="확인" close={() => modalHandler(false)}>
                    {"오류가 발생했습니다."}
                </Alert>
            )}
        </>
    );
};

export default ErrorInicis;
